import React from 'react';
import Text from 'react-format-text';
import {
  Flag,
  Header,
  Icon,
  Loader,
  Message,
  Popup,
  Segment,
  Statistic,
} from 'semantic-ui-react';

import { ArticleLink, BoardLink, UserLink } from '../../Links';
import { CustomContainer, FollowingBtn, FollowingBtnGuide, ShareBtn } from '../../common';
import { formatTimestamp, formatTimestampWithTimezone } from '../../Utils';

const STYLES = {
  CONTENT_DESKTOP: {
    paddingTop: '6em',
    fontSize: '16pt',
    lineHeight: '1.5em',
  },
  CONTENT_MOBILE: {
    paddingTop: '6em',
    fontSize: '12pt',
    lineHeight: '1.5em',
  },
};

const QUOTE_PREFIX = ['※', ':'];

const renderContent = (isMobile, content) => (
  <div>
    {content.split('\n').map((line) => {
      if (QUOTE_PREFIX.includes(line[0])) {
        return (
          <Header as={isMobile ? 'h4' : 'h3'} color="grey">{line}</Header>
        );
      }
      return (
        <div>
          <Text>
            {line}
          </Text>
          <br />
        </div>
      );
    })}
  </div>
);

const Statistics = ({
  loading,
  data,
}) => (loading ? (
  <Loader active />
) : (
  <div style={{ float: 'right' }}>
    <Statistic>
      <Statistic.Value>
        {data.num_replies}
      </Statistic.Value>
      <Statistic.Label>
        回文數
        {' '}
        <Icon name="arrow right" color="yellow" />
      </Statistic.Label>
    </Statistic>
    <Statistic floated="right">
      <Statistic.Value>
        {data.num_hates}
      </Statistic.Value>
      <Statistic.Label>
        噓文數
        {' '}
        <Icon name="thumbs outline down" color="red" />
      </Statistic.Label>
    </Statistic>
    <Statistic floated="right">
      <Statistic.Value>
        {data.num_likes}
      </Statistic.Value>
      <Statistic.Label>
        推文數
        {' '}
        <Icon name="thumbs outline up" color="blue" />
      </Statistic.Label>
    </Statistic>
  </div>
));

export default (props) => {
  const {
    data: {
      authorId,
      board,
      city,
      code2,
      content,
      country,
      datetime,
      id,
      title,
      updatedAt,
      url,
      active,
      isHidden,
    },
    authed,
    isMobile,
    pushesStats,
    replyTo,
  } = props;

  return (
    <CustomContainer>
      <Segment>
        {
          authed ? (
            <FollowingBtn
              platform="ptt"
              type="article"
              id={id}
            />
          ) : (
            <FollowingBtnGuide />
          )
        }
        <ShareBtn />
        <BoardLink
          id={board.id}
        >
          <Header
            as={isMobile ? 'h5' : 'h4'}
            floated="right"
            color="teal"
          >
            {board.alias ?? board.title}
            {' '}
            (
            {board.title}
            )
          </Header>
        </BoardLink>
        <CustomContainer>
          {
            !isMobile && (
              <Statistics
                loading={pushesStats.isFetching}
                data={pushesStats.data}
              />
            )
          }
          <Header
            as={isMobile ? 'h3' : 'h2'}
            floated="left"
          >
            {title}
            <Popup
              trigger={(
                <Header.Subheader
                  color="grey"
                  style={{ paddingTop: '4px' }}
                >
                  <Icon name="spy" />
                  <UserLink id={authorId}>
                    {authorId}
                  </UserLink>
                </Header.Subheader>
              )}
              content="使用者ID"
              inverted
            />
            <Popup
              trigger={(
                <Header.Subheader
                  color="grey"
                  style={{ paddingTop: '4px' }}
                >
                  <Icon name="calendar outline" />
                  <span>{formatTimestamp(datetime)}</span>
                </Header.Subheader>
              )}
              content="發文時間"
              inverted
            />
            {
              code2
              && (
                <Popup
                  trigger={(
                    <Header.Subheader
                      color="grey"
                      style={{ paddingTop: '4px' }}
                    >
                      <Icon name="location arrow" />
                      {city}
                      {' '}
                      (
                      {country}
                      {' '}
                      <Flag name={code2} />
                      )
                    </Header.Subheader>
                  )}
                  content="發文IP位置"
                  inverted
                />
              )
            }
            {
              replyTo
              && (
                <Popup
                  trigger={(
                    <Header.Subheader
                      color="grey"
                      style={{ paddingTop: '4px' }}
                    >
                      <Icon name="reply" />
                      <ArticleLink id={replyTo.id}>
                        {replyTo.title}
                      </ArticleLink>
                      (
                      <UserLink id={replyTo.author_id}>
                        {replyTo.author_id}
                      </UserLink>
                      )
                      @
                      {' '}
                      {formatTimestamp(replyTo.datetime)}
                    </Header.Subheader>
                  )}
                  content="回復原始文章"
                  inverted
                />
              )
            }
          </Header>
          <p style={isMobile ? STYLES.CONTENT_MOBILE : STYLES.CONTENT_DESKTOP}>
            {renderContent(isMobile, content)}
            {
              isHidden && (
                <Message color="olive" size="mini">
                  <Message.Header>
                    因特殊原因及原作者要求 無法顯示文章內容
                  </Message.Header>
                </Message>
              )
            }
            <br />
            <a
              style={{
                color: 'grey',
                fontSize: isMobile ? '10pt' : '12pt',
              }}
              href={url}
              target="__blank"
            >
              <Icon name="external share" />
              原文連結
            </a>
          </p>
          {
            !active && (
              <Message negative>
                <Message.Header>
                  此文章已被刪除囉!!
                </Message.Header>
              </Message>
            )
          }
        </CustomContainer>
      </Segment>
    </CustomContainer>
  );
};
